<template>
  <v-content>
    <datetime
      ref="startdatetime"
      v-model="inputTime"
      input-class="inputdatetimeclass"
      :minute-step="10"
      :phrases="{ok: 'OK', cancel: 'ABBRECHEN'}"
      class="theme-event datetimepicker"
      input-id="start"
      auto
      :title="time"
      :format="'HH:mm'"
      type="time"
      @close="$v.time.$touch()">
      <template
        slot="button-cancel">
        <!-- <v-btn
          flat 
          color="primary"> -->
        ABBRECHEN
        <!-- </v-btn> -->
      </template>
      <template
        slot="button-confirm">
        <!-- <v-btn
          flat 
          color="primary"> -->
        OK
        <!-- </v-btn> -->
      </template>
    </datetime>
    <v-card 
      flat
      class="my-3 card-event"
      :style="catColor">
      <form @submit.prevent="onCreateEvent">
        <v-btn 
          id="eventSign"
          style="margin: 155px 0  0 -12px; height: 30px; width: 30px; cursor: default;"
          absolute
          depressed
          fab
          small
          dark 
          color="pink lighten-1">
          <v-icon small>
            fas fa-star
          </v-icon>
        </v-btn>



        <v-btn 
          v-if="newCroppaImg"
          style="transform: translate(7px, -7px);  right: 0; height: 30px; width: 30px;"
          color="red"
          dark
          absolute
          right
          fab
          class="elevation-10"
          @click="removeCroppaImg">
          <v-icon 
            small>
            fas fa-times
          </v-icon>
        </v-btn>

        <!-- <v-btn 
          v-if="newCroppaImg"
          style="transform: translate(-5px, 72px); height: 26px; width: 26px;"
          absolute
          fab
          color="grey darken-1"
          dark
          @click="myCroppa.rotate()">
            
          <v-icon 
            small>fas fa-rotate-right</v-icon>
        </v-btn> -->
     
        <v-img
          height="170"
          class="croppa-background text-xs-center"
          :src="require('@/assets/camera_event_big.png')"
          :style="{'background-image': 'url(' + standardImgUrl + ')'}">
          <!-- <div> -->
          <!-- <div 
            class="croppa-container">  -->
          <croppa 
            v-model="myCroppa"
            :auto-sizing="true"
            :quality="2"
            class="croppa-element"
            accept="image/*"
            :file-size-limit="10000000"
            placeholder=""
            :disabled="false"
            :prevent-white-space="true"
            :show-remove-button="false"
            :zoom-speed="5"
            @file-choose="handleCroppaFileChoose"
            @file-size-exceed="handleCroppaFileSizeExceed"
            @file-type-mismatch="handleCroppa"
            @image-remove="handleCroppa"
            @move="handleCroppa"
            @zoom="handleCroppa"
              
            @click="$v.newCroppaImg.$touch()">
            <!-- <img 
              slot="placeholder"
              :src="camera_event"> -->
            <!-- <img
              slot="initial"
              crossOrigin="anonymous"  
              :src="require('@/assets/EventHeader/PartyHeader.jpg')"> -->
          </croppa>
          <!-- </div> -->
        </v-img>





        <!-- TODO: Text/Translate -->
        <!-- Alles       -->
        <v-card-text 
          :style="{ 'background-color': cardInfoColor, 'padding-bottom': showMap ? '16px' : '0px' }">
          <v-layout 
            row 
            wrap>
            <v-flex 
              xs12>
              <v-text-field
                id="title"
                v-model.trim="title"
                :style="!$v.title.$error ? 'margin-bottom: -12px' : ''"
                solo
                flat
                :error-messages="titleErrors"
                background-color="grey lighten-2" 
                prepend-inner-icon="fas fa-star"
                name="title"
                label="Title"
                @change="$v.title.$touch()"
                @blur="$v.title.$touch()">
              </v-text-field>
            </v-flex>
            
            <v-flex 
              xs12>
              <v-dialog
                ref="dialogDate"
                v-model="modalDate"
                :return-value.sync="date"
                persistent
                full-width
                width="290px">
                <v-text-field
                  slot="activator"
                  :style="!$v.date.$error ? 'margin-bottom: -12px' : ''"
                  :value="date | dateLong"
                  :error-messages="dateErrors"

                  solo 
                  flat
                  background-color="grey lighten-2"
                  label="Date"
                  prepend-inner-icon="fas fa-calendar"
                  readonly
                  @change="$v.date.$touch()"></v-text-field>
                <v-date-picker 
                  v-model="date"
                  first-day-of-week="1"
                  class="roundedcard"
                  color="pink lighten-1"
                  :min="dateToday"
                  locale="locale"
                  scrollable
                  @input="$refs.dialogDate.save(date)"
                  @blur="$refs.dialogDate.save(date)">
                  <v-spacer></v-spacer>
                  <v-btn 
                    flat 
                    color="primary" 
                    @click="modalDate = false"
                    @blur="$v.date.$touch()">
                    Abbrechen
                  </v-btn>
                  <v-btn 
                    flat 
                    color="primary" 
                    @blur="$v.date.$touch()"
                    @click="$refs.dialogDate.save(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>



            <v-flex 
              xs12>
              <v-text-field 
                :value="time"
                :style="!$v.time.$error ? 'margin-bottom: -12px' : ''"
                solo 
                  
                flat 
                :error-messages="timeErrors"
                background-color="grey lighten-2"
                label="Time"
                prepend-inner-icon="fas fa-clock"
                readonly
                @change="$v.time.$touch()"
                @click="$refs.startdatetime.isOpen = true">
              </v-text-field>
            </v-flex>

            <v-flex 
              xs12>
              <v-dialog
                ref="dialogMainCat"
                v-model="modalMainCat"
                persistent
                full-width
                width="290px">
                <v-text-field
                  slot="activator"
                  v-model="mainCat"
                  solo 
                  :append-icon="mainCatIcon ? mainCatIcon : ''"
                  :background-color="mainCat === '' ? 'grey lighten-2' : mainCatColor"
                  :dark="mainCat !== '' ? true : false"
                  :style="!$v.mainCat.$error ? 'margin-bottom: -12px' : ''"
                  :error-messages="mainCatErrors"

                  flat 
                  label="Hauptkategorie"
                  readonly></v-text-field>
                <v-card
                  class="text-xs-center roundedcard">
                  <v-card-text>
                    <div 
                      class="text-xs-center headline primary--text font-italic" 
                      color="primary">
                      Hauptkategorie
                    </div>
                  </v-card-text>
                  <v-layout 
                    align-start
                    justify-center
                    row 
                    wrap>
                    <v-flex
                      v-for="cat in orderedCategories"
                      :key="cat.title"
                      xs6>
                      <v-btn 
                        :color="cat.color"
                        :text-color="cat.color"
                        style="width: 120px;"
                        :disabled="cat.title === secondCat ? true : false"
                        dark
                        @click="selectMainCat(cat)">
                        <v-icon 
                          :color="'white'"
                          class="mr-2">
                          {{ cat.icon }}
                        </v-icon>{{ cat.title }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-spacer></v-spacer>
                  <v-btn 
                    flat 
                    color="primary" 
                    @click="modalMainCat = false"
                    
                    @blur="$v.mainCat.$touch()">
                    Cancel
                  </v-btn>
                </v-card>
              </v-dialog>
            </v-flex>


            <v-flex 
              xs12>
              <v-btn
                v-if="!addSecondCat"
                class="mt-0 grey--text text--darken-1"
                depressed
                block
                color="grey lighten-2"
                small
                @click="clickAddSecondCat">
                <v-icon
                  left
                  small>
                  far fa-plus-circle
                </v-icon>Nebenkategorie hinzufügen
              </v-btn>
              <v-dialog
                v-if="addSecondCat"
                ref="dialogSecondCat"
                v-model="modalSecondCat"
                persistent
                full-width
                width="290px">
                <v-text-field
                  slot="activator"
                  v-model="secondCat"
                  style="margin-bottom: -18px"
                  solo 
                  
                  :append-icon="secondCatIcon ? secondCatIcon : ''"
                  
                  :background-color="secondCat === '' ? 'grey lighten-2' : secondCatColor"
                  :dark="secondCat !== '' ? true : false"
                  flat 
                  label="Nebenkategorie"
                  readonly>
                  <v-icon
                    slot="prepend"
                    color="primary"
                    @click="removeSecondCat">
                    far fa-minus-circle
                  </v-icon>
                </v-text-field>
                <v-card 
                  class="text-xs-center roundedcard">
                  <v-card-text>
                    <div 
                      class="text-xs-center headline primary--text font-italic" 
                      color="primary">
                      Nebenkategorie
                    </div>
                  </v-card-text>
                  <v-layout 
                    align-start
                    justify-center
                    row 
                    wrap>
                    <v-flex
                      v-for="cat in orderedCategories"
                      :key="cat.title"
                      xs6 
                      text-xs-center>
                      <v-btn 
                        :color="cat.color"
                        :text-color="cat.color"
                        style="width: 120px;"
                        :disabled="cat.title === mainCat ? true : false"
                        dark
                        @click="selectSecondCat(cat)">
                        <v-icon 
                          :color="'white'"
                          class="mr-2">
                          {{ cat.icon }}
                        </v-icon>{{ cat.title }}
                      </v-btn>
                    </v-flex>
                  </v-layout>
                  <v-spacer></v-spacer>
                  <v-btn 
                    flat 
                    color="primary" 
                    @click="removeSecondCat">
                    {{ secondCat ? 'Remove' : 'Cancel' }}
                  </v-btn>
                </v-card>
              </v-dialog>
            </v-flex>
            

            <v-flex 
              xs12>
              <v-btn
                v-if="!addLink"
                class="mb-3 grey--text text--darken-1"
                depressed
                small
                block
                color="grey lighten-2"
                @click="addLink = true">
                <v-icon
                  left
                  small>
                  far fa-plus-circle
                </v-icon>Website hinzufügen
              </v-btn>
              
              <v-text-field
                v-if="addLink"
                id="link"
                v-model.trim="link"
                class="mt-2"
                :style="!$v.link.$error ? 'margin-bottom: -12px' : ''"
                solo
                flat
                :error-messages="linkErrors"
                background-color="grey lighten-2" 
                prepend-inner-icon="far fa-globe-americas"
                name="Link"
                label="Website"
                @change="$v.link.$touch()"
                @blur="$v.link.$touch()">
                <v-icon
                  slot="prepend"
                  color="primary"
                  @click="removeLink">
                  far fa-minus-circle
                </v-icon>
              </v-text-field>
            </v-flex>
            <!-- <v-flex 
              xs12 
              style="margin-bottom: -12px">

              <v-select
                v-model="mainCat"
                :items="categories"
                item-text="title"
                label="Hauptkategorie"
                :append-icon="mainCat.icon"
                solo
                :dark="mainCat !== '' ? true : false"
                dense
                :rules="[rules.required]"
                flat
                return-object
                :background-color="mainCat === '' ? 'grey lighten-2' : mainCat.color"></v-select>
                 
            </v-flex> -->
            <!-- <v-flex 
              xs12 
              style="margin-bottom: -12px">
           
              <v-select
                v-model="secondCat"
                :items="categories"
                item-text="title"
                label="Nebenkategorie"
                :append-icon="secondCat.icon"
                solo
                :dark="secondCat !== '' ? true : false"
                dense
                flat
                return-object
                :background-color="secondCat === '' ? 'grey lighten-2' : secondCat.color"></v-select>

              
            </v-flex> -->
            <v-flex 
              xs12>
              <v-text-field
                id="autocomplete-event"
                v-model="mylocationinput"
                

                solo 
                flat 
                :loading="loadingGeolocate"
                :style="!$v.mycoordinates.$error ? 'margin-bottom: -12px' : ''"
                :error-messages="mylocationinputErrors"
                append-icon="fas fa-location"
                placeholder="Location"
                background-color="grey lighten-2"
                prepend-inner-icon="fas fa-map-marker-alt"
                name="Location"
                label="Location"
                @focus="initAutocomplete"
                @click:append="initGeolocator"
                @change="$v.mycoordinates.$touch()"
                @blur="$v.mycoordinates.$touch()">
              </v-text-field>
            </v-flex>
          </v-layout>


      
          <v-layout 
            v-show="showMap"  
            mt-1

            row 
            fill-height>
            <v-flex 
              
              xs12>
              <div 
                id="map-event" />
              <div class="mt-2 grey--text caption text-xs-right">
                <!-- {{ mylocation }} -->
                {{ mylocationinput !== mylocation ? mylocation : '' }}
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>


        <v-card-text>
          <!-- Here is some text -->
        
          <v-textarea
            id="description"
            v-model="description"
            :style="!$v.description.$error ? 'margin-bottom: -12px' : ''"
            :error-messages="descriptionÈrrors"
            solo
            flat
            background-color="grey lighten-2"
            name="description"
            no-resize
            prepend-inner-icon="far fa-bars"
            label="Description"
            @change="$v.description.$touch()"
            @blur="$v.description.$touch()">
          </v-textarea>
          <!-- <div>date: {{ date }}</div>
          <div>time: {{ time }}</div>
          <div>submitDateTime: {{ submitDateTime }}</div> -->
          <!-- <div>mylocationinput: {{ mylocationinput }}</div>
          <div>mylocation: {{ mylocation }}</div>
          <div>mycoordinates: {{ mycoordinates }}</div>
          <div>markercoordinates: {{ markercoordinates }}</div> -->
         
          <div 
            v-if="isPast" 
            class="text-xs-center red--text caption">
            {{ isPastText }}
          </div>
          <div 
            v-else-if="!formIsValid" 
            class="text-xs-center red--text caption">
            {{ errorMessage }}
          </div>
          
          <!-- <div 
            v-if="$v.newCroppaImg.$error" 
            class="text-xs-center red--text caption">
            Image is required.
          </div> -->
        </v-card-text>
  



        <v-divider light></v-divider>

        <v-card-actions>
          <v-layout>
            <v-flex 
           
              align-center>
            </v-flex>
         
            <v-flex>
              <!-- :disabled="!formIsValid" -->
              <v-btn 
                :loading="this.$store.getters.loading"
                type="submit" 
                :dark="formIsValid"
                class="my-2"
                :class="formIsValid ? mainCatColor : 'primary lighten-1'"
                @click="$v.$touch()">
                {{ formIsValid ? 'Create Event' : 'Check Fields' }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-content>
</template>

<script>
/* global google */

import { mapState, mapGetters } from 'vuex'
import { orderBy } from 'lodash'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  
 
  data() {
    return {
      myCroppa: {},
      newCroppaImg: false,


      title: '',
      errorMessage: null,

      modalDate: false,
      date: null,
      dateToday: new Date().toISOString().substr(0, 10),

      inputTime: '',

      isPastText: 'Zeit liegt in der Vergangenheit',
      // time: new Date().toLocaleTimeString('de-DE', {
      //   hour: '2-digit',
      //   minute: '2-digit'
      // }),

      modalMainCat: false,
      mainCat: '',
      mainCatIcon: '',
      mainCatColor: '',
      catColor: 'border: 1px solid rgba(0, 0, 0, 0.4); filter: drop-shadow(2px 2px 5px rgba(0, 0, 0, 0.4));',
      cardInfoColor: 'rgba(0, 0, 0, 0.05)',

      modalSecondCat: false,
      secondCatIcon: '',
      seocondCatColor: '',
      secondCat: '',
      addSecondCat: false,


      link: '',
      addLink: false,

      mylocationinput: '',    
      mylocation: '',    
      mycoordinates: '',
      markercoordinates: '',

      description: '',
    
    
      image: null,
    
      showMap: false,

      map: null,
      autocomplete: null,
      pos: null,
      geocoder: null,
      marker: null,

      loadingGeolocate: false
    }
  },
  validations: {
    newCroppaImg: {
      // required
    },
    title: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(50)
    },
    link: {
      minLength: minLength(4),
      maxLength: maxLength(50)
    },
    date: {
      required
    },
    time: {
      required
    },
    mainCat: {
      required
    },
    mylocationinput: {
      required
    },
    mylocation: {
      required
    },
    mycoordinates: {
      required
    },
    description: {
      required,
      maxLength: maxLength(10000)
    }
  },
  
  computed: {
    time() {
      if (this.inputTime !== '') {
        const date = new Date(this.inputTime)

        // return this.time.getHours()
        return date.toLocaleTimeString([
          this.locale
        ], {
          hour: '2-digit',
          minute: '2-digit'
        })
      } else {
        return ''
      }
      
    }, 
    // newCroppaImgErrors() {
    //   const errors = []
    //   if (!this.$v.newCroppaImg.$dirty) return errors
    //   !this.$v.newCroppaImg.required && errors.push('Image is required.')
    //   return errors
    // },
    titleErrors() {
      const errors = []
      if (!this.$v.title.$dirty) return errors
      !this.$v.title.maxLength && errors.push('Title must not have more than ' + this.$v.title.$params.maxLength.max + ' letters.')
      !this.$v.title.minLength && errors.push('Title must have at least ' + this.$v.title.$params.minLength.min + ' letters.')
      !this.$v.title.required && errors.push('Title is required.')
      return errors
    },
    linkErrors() {
      const errors = []
      if (!this.$v.link.$dirty) return errors
      !this.$v.link.maxLength && errors.push('Website must not have more than ' + this.$v.link.$params.maxLength.max + ' letters.')
      !this.$v.link.minLength && errors.push('Website must have at least ' + this.$v.link.$params.minLength.min + ' letters.')
      return errors
    },
    dateErrors() {
      const errors = []
      if (!this.$v.date.$dirty) return errors
      !this.$v.date.required && errors.push('Date is required.')
      return errors
    },
    timeErrors() {
      const errors = []
      if (!this.$v.time.$dirty) return errors
      this.isPast && errors.push('')
      !this.$v.time.required && errors.push('Time is required.')
      return errors
    },
    mainCatErrors() {
      const errors = []
      if (!this.$v.mainCat.$dirty) return errors
      !this.$v.mainCat.required && errors.push('Categorie is required.')
      return errors
    },
    mylocationinputErrors() {
      const errors = []
      if (!this.$v.mycoordinates.$dirty) return errors
      !this.$v.mylocationinput.required && errors.push('Location is required.')
      !this.$v.mylocation.required && errors.push('Location is required.')
      !this.$v.mycoordinates.required && errors.push('Location is required.')
      return errors
    },
    descriptionÈrrors() {
      const errors = []
      if (!this.$v.description.$dirty) return errors
      !this.$v.description.maxLength && errors.push('Title must not have more than ' + this.$v.description.$params.maxLength.max + ' letters.')
      !this.$v.description.required && errors.push('Description is required.')
      return errors
    },
    isPast() {
      if (this.time !== '' && this.submitDateTime <= new Date())
      {
        return true
      } else {
        return false
      }
    },
    ...mapState({
      categories: state => state.categories
    }), 
    ...mapGetters({
      locale: 'locale',
      error: 'error'
    }),
    orderedCategories() {
      return orderBy(this.categories, 'orderCreate')
    },
   
    submitDateTime() {
      const date = new Date(this.date)
      if (this.time === '') {
        return null
      } else {
        if (typeof this.time === 'string') {
          let hours = this.time.match(/^(\d+)/)[1]
          let minutes = this.time.match(/:(\d+)/)[1]
          date.setHours(hours)
          date.setMinutes(minutes)
        } else {
          date.setHours(this.time.getHours())
          date.setMinutes(this.time.getMinutes())
        }
        return date
      }
    },
    standardImage () {
      if (this.mainCat === '') {
        return 'OpeningHeader.jpg'
      } else {
        let name = String(this.mainCat).concat('Header.jpg')
        return name
      }
    },
    standardImgUrl() {
      if (this.mainCat === '') {
        return require('@/assets/EventHeader/EventHeader.jpg')
      } else {
        let name = String(this.mainCat).concat('Header.jpg')
        
        return require('@/assets/EventHeader/' + name)
      }
     
    },


    // with vuelidate
    formIsValid() {
      
      return (
        // !this.$v.newCroppaImg.$invalid &&
        // this.myCroppa.imageSet &&
        !this.$v.title.$invalid &&
        !this.$v.link.$invalid &&
        !this.$v.date.$invalid &&
        !this.$v.time.$invalid &&
        this.submitDateTime !== null &&
        !this.isPast &&
        !this.$v.mainCat.$invalid &&
        this.mainCat !== this.secondCat &&
        !this.$v.mylocationinput.$invalid &&
        !this.$v.mylocation.$invalid &&
        !this.$v.mycoordinates.$invalid &&
        !this.$v.description.$invalid
      )
    },
   


    
    // camera_event () {
    //   if (window.innerWidth < 400) {
    //     return require('@/assets/camera_event.png')
    //   } else {
    //     return require('@/assets/camera_event_big.png')
    //   }
    // }
    
  },
  
  mounted() {
    var self = this

    self.map = new google.maps.Map(document.getElementById('map-event'), {
      center: {lat: 0, lng: 0},
      zoom: 0,
      disableDefaultUI: true,
      gestureHandling: 'greedy',
      clickableIcons: false 
    })

        
    self.marker = new google.maps.Marker({
      position: null,
      map: self.map,
      // title: 'Here'
    })

    self.map.addListener('click', function(event) {
      // 3 seconds after the center of the map has changed, pan back to the
      // marker.
      self.marker.setPosition(event.latLng)
      self.map.panTo(event.latLng)
      // window.setTimeout(function() {
      //   map.panTo(marker.getPosition())
      // }, 3000)
      var coords = {
        lat: event.latLng.lat(), 
        lng: event.latLng.lng()
      }
      self.markercoordinates = coords
      self.reverseGeocoding(coords)
    })


    // this.geolocate()

    // this.$refs.address.focus()


    self.autocomplete = new google.maps.places.Autocomplete(
      (document.querySelector('#autocomplete-event'))
      // ,
      // {
      //   // types: [
      //   //   // 'address'
      //   //   'geocode'
      //   // ]
      // }
    )

    self.autocomplete.setFields([
      'formatted_address',
      'geometry',
      'place_id'
    ])

    self.autocomplete.addListener('place_changed', () => {
      let place = self.autocomplete.getPlace()
      // console.log(place)
      // let ac = place.address_components
      // let lat = place.geometry.location.lat()
      // let lon = place.geometry.location.lng()
      // let city = ac[0]['short_name']
      
      // this.location = place.formatted_address
      // console.log(`The user picked ${city} with the coordinates ${lat}, ${lon}`)

      // if (self.marker !== null) {
      self.marker.setPosition(place.geometry.location)
      // self.map.setCenter(place.geometry.location)
      self.map.panTo(place.geometry.location)
      self.map.setZoom(15)
      // } else {
      //   self.marker = new google.maps.Marker({
      //     position: place.geometry.location,
      //     map: self.map,
      //     title: 'Here'
      //   })
      //   self.map.setCenter(place.geometry.location)
      // }
      self.mylocationinput = place.formatted_address
      self.mylocation = place.formatted_address
      self.mycoordinates = {
        lat: place.geometry.location.lat(), 
        lng: place.geometry.location.lng()
      }
    })
  },
  
  methods: {
    initGeolocator () {
      this.showMap = true
      this.loadingGeolocate = true
     
      this.geolocateLocation()
    },

    initAutocomplete () {
      this.showMap = true
      this.geolocateAutocomplete()
    },

    handleCroppaFileSizeExceed () {
      // this.$store.commit('setError', { message: 'WoW! This is a really big file! Try it with something smaller...' })
      this.errorMessage = 'WoW! This is a really big file! Try it with something smaller...'
      this.newCroppaImg = false
      this.myCroppa.remove()
      this.image = null
    },

    selectMainCat(cat) {
      this.mainCat = cat.title
      this.mainCatIcon = cat.icon
      this.mainCatColor = cat.color
      this.catColor = 'border: 1px solid ' + cat.colrgba + ';' + 'filter: drop-shadow(2px 2px 5px ' + cat.colrgba + ');'
      this.cardInfoColor = cat.colrgbaback
      this.modalMainCat = false
    },

    selectSecondCat(cat) {
      this.secondCat = cat.title
      this.secondCatIcon = cat.icon
      this.secondCatColor = cat.color
      this.modalSecondCat = false
    },
    clickAddSecondCat() {
      this.addSecondCat = true
      this.modalSecondCat = true

    },
    removeSecondCat() {
      this.secondCatIcon = ''
      this.seocondCatColor = ''
      this.modalSecondCat = false
      this.secondCat = ''
      this.addSecondCat = false

    },
    removeLink() {
      this.addLink = false
      this.link = ''

    },

    geolocateAutocomplete() {
      if (navigator.geolocation) {
        var self = this
        navigator.geolocation.getCurrentPosition(position => {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          var circle = new google.maps.Circle({
            center: pos,
            radius: position.coords.accuracy
          })
          self.autocomplete.setBounds(circle.getBounds())
        })
      }
    },

    geolocateLocation() {
      if (navigator.geolocation) {
        var self = this
        navigator.geolocation.getCurrentPosition(position => {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          // self.map.setCenter(pos)
          self.map.panTo(pos)
          self.map.setZoom(15)
          self.marker.setPosition(pos)
          
          self.reverseGeocoding(pos)
        })
      } else {
        self.loadingGeolocate = false
      }
    },



    reverseGeocoding(latLng) {
      var self = this

      if (self.geocoder === null) {
        self.geocoder = new google.maps.Geocoder
      } else {

      }

      self.geocoder.geocode({'location': latLng}, function(results, status) {
        if (status === 'OK') {
          self.loadingGeolocate = false

          if (results[0]) {
            self.loadingGeolocate = false

            // var location1 = results[0].formatted_address
            // console.log(results[0].formatted_address)
            self.mylocationinput = results[0].formatted_address
            self.mylocation = results[0].formatted_address
            self.mycoordinates = latLng
            console.log('mycoods', self.mycoordinates)

            if (self.marker !== null) {
              self.marker.setPosition(results[0].geometry.location)
              self.map.setCenter(results[0].geometry.location)
            } else {
              self.marker = new google.maps.Marker({
                position: results[0].geometry.location,
                map: self.map,
                title: 'Here'
              })
              self.map.setCenter(results[0].geometry.location)
            }
          } else {
            console.log('No results found')
            self.loadingGeolocate = false

            self.mylocationinput = 'No results found'
            self.mylocation = ''
            self.mycoordinates = ''
          }
        } else {
          console.log('Geocoder failed due to: ' + status)
          self.loadingGeolocate = false
          self.mylocationinput = 'Geocoder failed due to: ' + status
          self.mylocation = ''
          self.mycoordinates = ''
        }
      })
    },



    handleCroppaFileChoose () {
      this.newCroppaImg = true
    },
    removeCroppaImg () {
      this.myCroppa.remove()
      this.newCroppaImg = false
      this.image = null
    },
    handleCroppa () {

    },

    
    // allowedStep: m => m % 5 === 0,

    onCreateEvent() {
      if (!this.formIsValid) {
        this.errorMessage = 'Bitte alle Felder ausfüllen!'
        this.$v.$touch()
      } else {
        let compressor = 0.9
        
        if (this.newCroppaImg === true) {
          if (this.myCroppa.chosenFile.size > 10000000) {
            compressor = 0.5
          } else if (this.myCroppa.chosenFile.size > 5000000){
            compressor = 0.7
          } else {
            compressor = 0.8
          }
          this.myCroppa.generateBlob((blob) => {
            // write code to upload the cropped image file (a file is a blob)
            this.image = blob
            const eventData = {
              image: this.image,
              standardImage: this.standardImage,
              title: this.title,
              link: this.link,
              date: this.submitDateTime,
              mainCat: this.mainCat,
              secondCat: this.secondCat,
              location: this.mylocation,
              coordinates: this.mycoordinates,
              description: this.description.replace(/\s\s\s+/g, ' - ')
            }
            this.$store.dispatch('createEvent', eventData)
           
          
          // console.log('blob', this.image)
          }, 'image/jpeg', compressor)
        } else {
          this.image = null
          const eventData = {
            image: this.image,
            standardImage: this.standardImage,
            title: this.title,
            link: this.link,
            date: this.submitDateTime,
            mainCat: this.mainCat,
            secondCat: this.secondCat,
            location: this.mylocation,
            coordinates: this.mycoordinates,
            description: this.description.replace(/\s\s\s+/g, ' - ')
          }
          this.$store.dispatch('createEvent', eventData)
        }
        
        
      // this.$router.push('/timeline')
      }
    },
   
    
  
  }
    
}

</script>


    <style 
      lang="scss" 
      scoped
      >


      #map-event {
        height: 180px;
        border-radius: 16px;
      }

      .card-event {
      background-color: rgba(255, 255, 255, 1);
      /* border: 1px solid rgba(230, 27, 88, 0.4); */
      border-radius: 16px;
      /* filter: drop-shadow(2px 2px 5px rgba(230, 27, 88, 0.4)); */
      }

      .card-avatar {
      border-radius: 50%;
      height: 48px;
      width: 48px;
      }

      .card-participants {
      border-radius: 50%;
      border: 2px solid white;
      height: 26px;
      width: 26px;
      max-height: 26px;
      max-width: 26px;
      margin-left: -8px;
      }

      /* .card-info { */
      /* background-color: rgba(230, 27, 88, 0.05); */
      /* } */

      #eventSign {
      z-index: 5;
      border: 3px solid white;
      background-image: linear-gradient(330deg, #d81b60, #eeff41);
      }

      /* .wevent_icon_logo {
  height: auto;
  width: 100%;
  filter: invert(0.5) sepia(1) saturate(1) hue-rotate(175deg);
} */

.croppa-element {
  margin: 0px;
  display: block;
  height: 170px;
}

.croppa-container {
   background-color:  rgba(120, 144, 156, 0.4);

 }
 
 .croppa-container:hover {
   opacity: 1;
   background-color:  rgba(120, 144, 156, 0.6);
 }

 .croppa-background {
   /* require('@/assets/EventHeader/PartyHeader.jpg') */
   /* background-image: url('../../assets/EventHeader/PartyHeader.jpg'); */
   /* background-size: 100% auto; */
   background-size: cover;
    background-position: center; 
   /* background-image: url('../../../assets/Background.svg'); */
 /* background-color: rgb(69, 94, 107); */
  border-radius: 15px 15px 0 0;
 }

    </style>